export default "__VITE_ASSET__5dd159c9__"